import { ReactNode } from 'react'
import SideNav from './SideNav'
import OnboardingModal from './OnboardingModal'
import { useChatStore } from '@/store/chatStore'
import { cn } from '@/lib/utils'

interface LayoutProps {
  children: ReactNode
  fullWidth?: boolean
}

export default function Layout({ children, fullWidth = false }: LayoutProps) {
  const sidebarExpanded = useChatStore(s => s.sidebarExpanded)
  const onboardingCompleted = useChatStore(s => s.userPreferences?.onboardingCompleted ?? false)

  return (
    <div className="h-screen overflow-hidden flex">
      <SideNav />
      <main
        className={cn(
          'flex-1 h-screen overflow-y-auto transition-all duration-200',
          sidebarExpanded ? 'ml-60' : 'ml-14 md:ml-16'
        )}
      >
        {fullWidth ? (
          <div className="w-full h-full min-h-0 flex flex-col">
            <div className="min-h-0 flex-1 flex flex-col">
              {children}
            </div>
          </div>
        ) : (
          <div className="px-3 py-4 md:px-6 md:py-6 max-w-7xl mx-auto w-full h-full flex flex-col">
            <div className="min-h-0 flex-1 flex flex-col">
              {children}
            </div>
          </div>
        )}
      </main>
      {!onboardingCompleted && <OnboardingModal />}
    </div>
  )
}
